export interface CommunityReply {
  user: string;
  content: string;
  time: string;
}

export interface CommunityPost {
  id: string;
  title: string;
  author: string;
  tag: string;
  date: string;
  views: number;
  content: string[];
  images: string[];
  replyList: CommunityReply[];
}

export const communityTags = ["影视评论", "明星八卦", "活动交流", "追剧日常", "综艺讨论"];

export const communityList: CommunityPost[] = [
  {
    id: "echo-city-review",
    title: "刚看完《回声之城》，后劲太大了，来聊聊结尾",
    author: "深夜观影人",
    tag: "影视评论",
    date: "2026-08-03 22:14",
    views: 5820,
    content: [
      "刚从影院出来，脑子里全是最后那个长镜头。导演没有把答案直接给出来，但每一个细节其实都埋好了伏笔。",
      "我最喜欢的其实是中段那段声音处理，把主角的孤独感放得特别大。你们觉得结尾到底是不是开放式的？我倾向于他其实早就做出了选择。",
      "顺便安利一下这部片的配乐，单听也是享受。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=cinema%20audience%20silhouettes%20watching%20a%20glowing%20screen%20in%20a%20dark%20theater%2C%20warm%20artistic%20illustration%2C%20cinematic%20mood&width=800&height=500&seq=post-01&orientation=landscape",
    ],
    replyList: [
      { user: "胶片收藏家", content: "同意！那段声音设计真的绝，戴耳机看的话更明显。", time: "2026-08-03 22:40" },
      { user: "阿柚", content: "我觉得是开放式的，但情绪上已经给了答案，这就够了。", time: "2026-08-03 23:02" },
      { user: "落日放映厅", content: "配乐已经加到歌单了，循环一下午。", time: "2026-08-04 09:18" },
    ],
  },
  {
    id: "summer-festival-tips",
    title: "夏日音乐节第一天攻略，避坑指南来了",
    author: "现场小分队",
    tag: "活动交流",
    date: "2026-08-02 18:30",
    views: 4310,
    content: [
      "刚从现场回来，人真的超多！给大家整理几个实用建议：",
      "1. 尽量早点到，不然安检排队会很久；2. 带充电宝和防晒，白天几乎没遮挡；3. 美食区在东南角，人相对少一点。",
      "晚上的主舞台压轴千万别错过，灯光效果值回票价。明天我还会去，有问题可以留言！",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=outdoor%20summer%20music%20festival%20crowd%20with%20orange%20stage%20lights%20at%20dusk%2C%20energetic%20artistic%20illustration%2C%20warm%20vibrant%20mood&width=800&height=500&seq=post-02&orientation=landscape",
    ],
    replyList: [
      { user: "橙子汽水", content: "太及时了，明天正好去，感谢分享！", time: "2026-08-02 19:05" },
      { user: "小满", content: "请问可以带自拍杆进去吗？", time: "2026-08-02 19:22" },
      { user: "现场小分队", content: "@小满 可以，但主舞台前排不建议用，会挡人。", time: "2026-08-02 19:40" },
    ],
  },
  {
    id: "idol-charity-thoughts",
    title: "看到偶像办慈善演唱会，突然有点感动",
    author: "路人甲变身",
    tag: "明星八卦",
    date: "2026-07-26 21:00",
    views: 3680,
    content: [
      "本来是随手点进去的直播，结果看完一整场。最打动我的不是舞台多华丽，而是他们真的把收益捐给了孩子的艺术教育。",
      "这些年看过太多热闹的场面，但能坚持做点实事的，还是值得被记住。",
      "你们觉得偶像做公益的意义大吗？欢迎理性讨论。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=warm%20charity%20concert%20stage%20with%20soft%20amber%20lights%20and%20glowing%20hearts%2C%20artistic%20illustration%2C%20hopeful%20tone&width=800&height=500&seq=post-03&orientation=landscape",
    ],
    replyList: [
      { user: "柚子茶", content: "只要是真的做了事，就值得肯定。", time: "2026-07-26 21:30" },
      { user: "理性追星", content: "希望热度过去之后也能坚持，这才是最难的。", time: "2026-07-26 22:10" },
    ],
  },
  {
    id: "variety-new-season",
    title: "新一季综艺赛制改得好，还是改得太乱？",
    author: "综艺雷达",
    tag: "综艺讨论",
    date: "2026-07-19 20:15",
    views: 2990,
    content: [
      "老牌综艺回归，赛制大改，我看了两期，心情有点复杂。",
      "好处是节奏更快了，观众投票环节参与感强；但坏处是嘉宾之间的配合被打散了，少了一些自然的化学反应。",
      "你们更喜欢以前的慢节奏，还是现在的新玩法？",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=colorful%20playful%20abstract%20shapes%20and%20tvs%20in%20orange%20and%20teal%2C%20modern%20variety%20show%20illustration%2C%20fun%20graphic%20style&width=800&height=500&seq=post-04&orientation=landscape",
    ],
    replyList: [
      { user: "沙发土豆", content: "我站新玩法，看着不困。", time: "2026-07-19 20:50" },
      { user: "慢综爱好者", content: "还是喜欢以前那种聊天式的，更松弛。", time: "2026-07-19 21:33" },
    ],
  },
  {
    id: "korean-thriller-recommend",
    title: "最近迷上韩系悬疑，来互相安利",
    author: "深夜追剧",
    tag: "追剧日常",
    date: "2026-07-15 23:20",
    views: 4120,
    content: [
      "最近一口气补了好几部韩系悬疑，氛围感真的拉满。",
      "《深夜の信号》看得很上头，那种孤独感和悬念结合得特别好。有没有类似的推荐？最好是节奏慢一点但后劲大的。",
      "坐等评论区卧虎藏龙。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=foggy%20night%20forest%20with%20a%20glowing%20lone%20lamp%2C%20atmospheric%20mystery%20illustration%2C%20eerie%20warm%20tone&width=800&height=500&seq=post-05&orientation=landscape",
    ],
    replyList: [
      { user: "北极星", content: "推荐《最后一个目击者》，港片味很足。", time: "2026-07-16 00:05" },
      { user: "黑咖啡", content: "同好！我也在找这类，蹲评论。", time: "2026-07-16 08:40" },
      { user: "午夜场", content: "可以看看《东京的夏天》，虽然不是悬疑但氛围很对。", time: "2026-07-16 12:15" },
    ],
  },
  {
    id: "animation-festival-review",
    title: "国漫展逛了三小时，拍了好多图（多图）",
    author: "画笔不停",
    tag: "活动交流",
    date: "2026-07-03 16:45",
    views: 2540,
    content: [
      "国漫主题展最后一天终于去了，人是真的多，但值得！",
      "最喜欢的是原创短片展区，好多年轻创作者的作品都很有想法，画风也各有特色。周边区也逛了好久。",
      "明年一定要早点去，慢慢看。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=colorful%20animation%20art%20exhibition%20with%20stylized%20posters%20and%20warm%20lighting%2C%20artistic%20illustration%2C%20creative%20playful%20mood&width=800&height=500&seq=post-06&orientation=landscape",
    ],
    replyList: [
      { user: "分镜控", content: "哪几个短片值得补？求名单！", time: "2026-07-03 17:20" },
      { user: "画笔不停", content: "@分镜控 我整理一份放评论区置顶了。", time: "2026-07-03 17:55" },
    ],
  },
  {
    id: "city-of-echoes-detail",
    title: "《回声之城》里那些你可能忽略的细节盘点",
    author: "细节控",
    tag: "影视评论",
    date: "2026-07-30 14:00",
    views: 6210,
    content: [
      "二刷之后发现了好多第一遍没注意的细节，整理给大家。",
      "比如开场那个收音机的画面，其实和结尾形成了呼应；还有主角家里的照片墙，仔细看能发现时间线是错位的。",
      "这些设计让整部片值得反复观看。你们还发现了什么？",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=abstract%20futuristic%20memory%20fragments%20floating%20in%20warm%20orange%20light%2C%20artistic%20sci%20fi%20illustration%2C%20mysterious%20tone&width=800&height=500&seq=post-07&orientation=landscape",
    ],
    replyList: [
      { user: "胶片收藏家", content: "照片墙那个我完全没看出来，太细了！", time: "2026-07-30 14:35" },
      { user: "深夜观影人", content: "配乐里也有彩蛋，第二遍听才反应过来。", time: "2026-07-30 15:10" },
    ],
  },
  {
    id: "summer-drama-list",
    title: "暑期档剧单来了，这几部真的值得追",
    author: "追剧清单",
    tag: "追剧日常",
    date: "2026-07-08 10:30",
    views: 3870,
    content: [
      "整理了一份暑期档追剧清单，都是我自己看过的，附踩雷提醒。",
      "个人最推荐都市题材那部，节奏舒服，人物也很真实。有一部主打悬疑的前几集有点拖，我等完结再评价。",
      "大家最近都在追什么？评论区交流一下。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20warm%20lamp%20and%20a%20tv%20showing%20a%20glowing%20scene%2C%20artistic%20lifestyle%20illustration%2C%20relaxed%20evening%20tone&width=800&height=500&seq=post-08&orientation=landscape",
    ],
    replyList: [
      { user: "橙子汽水", content: "清单很实用，先收藏了！", time: "2026-07-08 11:00" },
      { user: "夜猫子", content: "那部悬疑我看到第五集弃了，你等我反馈。", time: "2026-07-08 22:40" },
    ],
  },
  {
    id: "actor-career-talk",
    title: "聊聊那些转型成功的演员，你最先想到谁",
    author: "影迷闲聊",
    tag: "明星八卦",
    date: "2026-06-29 19:50",
    views: 3310,
    content: [
      "最近看了几部老片，突然很想聊聊演员的转型。",
      "有些演员从偶像剧起步，后来靠一部现实题材彻底打开了戏路，这种成长真的很打动人。你觉得谁的转型最成功？",
      "理性讨论，不引战哈。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=warm%20theater%20stage%20with%20a%20single%20spotlight%20and%20red%20curtain%2C%20artistic%20illustration%2C%20elegant%20dramatic%20tone&width=800&height=500&seq=post-09&orientation=landscape",
    ],
    replyList: [
      { user: "老片新看", content: "我第一个想到的是一位从喜剧转正剧的演员，完全没违和感。", time: "2026-06-29 20:20" },
      { user: "路人甲变身", content: "转型最难的是观众的先入为主，能突破就很厉害。", time: "2026-06-29 21:05" },
    ],
  },
  {
    id: "festival-meetup",
    title: "有没有一起去看电影节的，约个搭子",
    author: "独行影迷",
    tag: "活动交流",
    date: "2026-07-12 13:10",
    views: 1980,
    content: [
      "一个人看电影节有点怂，想找同城的朋友一起。",
      "主要想看主竞赛单元的几部，时间大概是下周末。如果有兴趣可以在评论区留个言，我们建个小群。",
      "纯分享观影，不推销任何东西。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=elegant%20film%20festival%20entrance%20with%20warm%20lights%20and%20posters%2C%20artistic%20illustration%2C%20inviting%20evening%20mood&width=800&height=500&seq=post-10&orientation=landscape",
    ],
    replyList: [
      { user: "午夜场", content: "同城！算我一个。", time: "2026-07-12 13:40" },
      { user: "胶片收藏家", content: "我要看的那场在晚上，可以碰头。", time: "2026-07-12 14:10" },
      { user: "独行影迷", content: "好的，晚点私信联系你俩～", time: "2026-07-12 14:35" },
    ],
  },
  {
    id: "guitar-album-review",
    title: "时隔三年的回归专辑，听完整个人都安静了",
    author: "耳机党",
    tag: "影视评论",
    date: "2026-06-30 21:40",
    views: 2260,
    content: [
      "本来只是随手点开，结果整张循环了一晚上。",
      "这张专辑最难得的是不着急，每首歌都留了呼吸的空间。词也很真诚，没有刻意堆砌。",
      "如果最近有点累，推荐从中间那首慢歌开始听。",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=cozy%20music%20corner%20with%20headphones%20and%20warm%20string%20lights%2C%20artistic%20illustration%2C%20calm%20healing%20tone&width=800&height=500&seq=post-11&orientation=landscape",
    ],
    replyList: [
      { user: "小满", content: "被安利了，现在就去听。", time: "2026-06-30 22:00" },
      { user: "柚子茶", content: "中间那首真的顶，泪目。", time: "2026-07-01 09:15" },
    ],
  },
  {
    id: "action-movie-talk",
    title: "今年的动作片是不是越来越会拍了",
    author: "爆米花鉴赏家",
    tag: "影视评论",
    date: "2026-06-22 20:00",
    views: 2140,
    content: [
      "今年几部动作片看下来，最大的感受是打戏开始讲究故事逻辑了。",
      "不再是单纯堆场面，而是让动作服务于人物和情绪。这种变化挺好的。你们今年最喜欢哪场动作戏？",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=dynamic%20abstract%20action%20motion%20blur%20with%20orange%20sparks%2C%20artistic%20cinematic%20illustration%2C%20high%20energy%20tone&width=800&height=500&seq=post-12&orientation=landscape",
    ],
    replyList: [
      { user: "黑咖啡", content: "同意，现在打戏没逻辑真的看不下去。", time: "2026-06-22 20:45" },
    ],
  },
  {
    id: "romance-recommend",
    title: "适合夏夜看的治愈系爱情片，整理了几部",
    author: "慢生活",
    tag: "追剧日常",
    date: "2026-06-18 18:20",
    views: 2760,
    content: [
      "天太热不想出门的时候，就适合窝在沙发上看点温柔的东西。",
      "整理了几部节奏不快的爱情片，《纸飞机的约定》和《东京的夏天》都在里面。看完心里会软软的。",
      "你们夏夜最爱的下饭菜/下剧是什么？",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=summer%20evening%20balcony%20with%20soft%20warm%20lights%20and%20plants%2C%20cozy%20romantic%20illustration%2C%20gentle%20nostalgic%20tone&width=800&height=500&seq=post-13&orientation=landscape",
    ],
    replyList: [
      { user: "北极星", content: "《纸飞机的约定》看哭了，太干净了。", time: "2026-06-18 19:00" },
      { user: "夜猫子", content: "收藏了，周末安排上。", time: "2026-06-18 23:10" },
    ],
  },
  {
    id: "awards-prediction",
    title: "年度盛典提名预测，说说你心中的最佳",
    author: "颁奖季观察",
    tag: "明星八卦",
    date: "2026-06-21 11:30",
    views: 3020,
    content: [
      "盛典快到了，先来一波大胆预测。",
      "最佳影片我看好那部口碑科幻，最佳演员则是几部文艺片的争夺。当然预测就是图个乐，欢迎大家来打脸。",
      "你们心里的最佳是谁？",
    ],
    images: [
      "https://readdy.ai/api/search-image?query=glamorous%20golden%20trophy%20with%20sparkling%20bokeh%20on%20elegant%20warm%20backdrop%2C%20artistic%20awards%20illustration%2C%20luxurious%20celebration%20tone&width=800&height=500&seq=post-14&orientation=landscape",
    ],
    replyList: [
      { user: "老片新看", content: "科幻那部我支持，视效和情感都在线。", time: "2026-06-21 12:00" },
      { user: "影迷闲聊", content: "演员竞争太激烈了，谁拿都合理。", time: "2026-06-21 13:20" },
      { user: "细节控", content: "坐等提名公布来验证。", time: "2026-06-21 15:40" },
    ],
  },
];